export const wrapHistoryMethodWithEvent = function (type: any) {
  const orig = history[type];
  const historyEvent = new Event(type);
  return function () {
    const originalResult = orig.apply(this, arguments);
    //@ts-ignore
    historyEvent.arguments = arguments;
    window.dispatchEvent(historyEvent);
    return originalResult;
  };
};
